<template>
    <div v-if="cateInfo">
        <div class="is-main f-mb15">
            <div class="container">
                <section class="m-location f-mb10">
                    <span>当前位置：</span>
                    <a href="/">网站首页</a> &gt;
                    <a>{{ cateInfo.name }}</a>
                </section>
                <div class="m-pgpdbox1">

                    <div class="row f-mlrf10">
                        <section class="col-md-3 f-plr10 m-listlf f-md-mb15">
                            <div class="g-listlf hidden-sm hidden-xs">
                                <h1 class="hidden-sm hidden-xs u-tit">
                                    <span></span>
                                    {{ cateInfo.name }}
                                </h1>
                                <ul>
                                    <li v-for="(item, index) in childList" :key="index"
                                        :class="index == activeIndex ? 'u-active' : ''"
                                        @click="handleSelectChild(item, index)">
                                        <a :title="item.name">{{ item.name }}</a>
                                    </li>
                                </ul>
                            </div>
                        </section>

                        <section class="col-md-9 f-plr10 m-listrg">

                            <div class="m-titstyle1 f-clearfix f-mb5" v-if="selectedCateId !== '83'">
                                <span class="u-tit f-fl" v-if="activeIndex < 0">{{ cateInfo.name }}<em></em></span>
                                <span class="u-tit f-fl" v-else>{{ childList[activeIndex].name }}<em></em></span>
                                <div  style="display: flex;gap: 10px;padding: 10px">
                                    <el-input v-model="searchName" prefix-icon="el-icon-search" placeholder="请输入..."/>
                                    <el-button type="primary" @click="getArticleList"> 搜索</el-button>
                                </div>
                            </div>
                            <div v-else style=" padding: 10px 0;">
                                <div  style="display: flex;gap: 10px;margin-bottom: 10px;">
                                    <el-input v-model="searchName" prefix-icon="el-icon-search" placeholder="请输入交易名称"/>
                                    <el-button type="primary" @click="getArticleList"> 搜索</el-button>
                                </div>

                                <el-tabs stretch v-model="progressStatus" @tab-click="getArticleList">
                                    <el-tab-pane v-for="item in progressStatusList" :key="item.id"
                                                 :label="item.name" :name="item.id">
                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                            <div class="m-cglist m-liststyle1 f-md-mb15">
                                <ul>
                                    <li v-for="(item, index) in cateArticleList" :key="index"
                                        @click="handeleNavigate(item)">
                                        <span>{{ formDate(item.time) }}</span>
                                        <a :title="item.name" target="_blank">{{ item.title }}</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="text-right m-paginationyun7">
                                <div id="pagination" class="f-fr">

                                    <el-pagination layout="prev, pager, next" :page-size="15" :total="total"
                                                   @current-change="handleCurrenChange">
                                    </el-pagination>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from '@/api/api'

export default {
    name: "channel",
    data() {
        return {
            cateInfo: undefined,
            childList: [],
            cateArticleList: [],
            activeIndex: 0,
            total: 0,
            page: 1,
            selectedCateId: 0,
            progressStatusList: [{
                id: '1',
                name: "招标"
            }, {
                id: '2',
                name: "中标"
            }],
            progressStatus:'1',
            searchName:''
        }
    },
    created() {
        this.page = 1;
        this.loading()
    },
    methods: {

        handleCurrenChange(val) {
            this.page = val;
            this.loading()
        },
        loading() {
            let cateList = this.$store.getters.cateList;

            for (let index = 0; index < cateList.length; index++) {
                const item = cateList[index];
                if (this.$route.query.pid === item.id) {
                    this.cateInfo = this.$store.getters.cateList[index]

                    break;
                }

            }
            // this.$store.getters.cateList.forEach((item, index) => {
            //     if (this.$route.query.pid  === item.id) {
            //         this.cateInfo = this.$store.getters.cateList[index]
            //         document.title = this.cateInfo.name
            //     }
            // })

            console.log('cateInfo', this.cateInfo)
            this.childList = this.cateInfo.childs

            for (let index = 0; index < this.childList.length; index++) {
                const item = this.childList[index];
                if (this.$route.query.id === item.id) {
                    this.handleSelectChild(item, index);
                }
            }

            // if (this.$route.query.index == -1 ) {
            //     console.log('this.$route.query.index',this.$route.query.index)
            //     api.cateArticle({
            //         siteId: this.$store.getters.siteId,
            //         pCateId: this.$route.query.id,
            //         size: 50,
            //         page: this.page
            //     }).then(res => {
            //         this.cateArticleList = res.data;
            //         this.total = res.extra.total
            //     })
            // } else {
            //     this.handleSelectChild(this.$route.query.index)
            // }
        },
        handleSelectChild(cate, index) {
            this.activeIndex = index
            this.selectedCateId = cate.id
            this.getArticleList()

            // let queryParams = {
            //     page: this.page,
            //     pageSize: 15,
            //     siteId: cate.siteId,
            //     cateId: cate.id,
            //     status: 1
            // }
            // if (cate.id === '83') {
            //     queryParams.progressStatus = this.progressStatus
            // }
            // api.articlePage(queryParams).then(res => {
            //     this.cateArticleList = res.content
            //     this.total = res.total
            // })
        },

        getArticleList() {

            let queryParams = {
                page: this.page,
                pageSize: 15,
                siteId: this.$store.getters.siteId,
                cateId: this.selectedCateId,
                status: 1,
                name: this.searchName
            }
            if (this.selectedCateId === '83') {
                queryParams.progressStatus = this.progressStatus
            }
            api.articlePage(queryParams).then(res => {
                this.cateArticleList = res.content
                this.total = res.total
            })
        },
        handeleNavigate(item) {
            this.$router.push({
                path: `/detail?id=${item.id}`
            })
        }
    },
    watch: {
        '$store.state.activeId': function () {
            this.activeIndex = -1
            this.loading()
        }
    },
    computed: {
        formDate() {    // JS 不同时间格式转换(ISO时间&时间戳转北京时间)
            return date => {
                return date.substr(0, 10)
            }
        }
    }
}
</script>

<style scoped></style>
